import axios from "axios"

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    // baseURL: "http://202.91.9.14:6000",
    // headers: {
    //     'Content-Type': 'application/json',
    //     'User-Agent': '@m!k0mXv=#neMob!le',
    //     'Content-Length': 86,
    //     'Host': '202.91.9.14:6000',
    //     'Connection': 'Keep-Alive',
    //     'Accept-Encoding': 'gzip'
})

api.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

export default {
    presenceQR(data) {
        return api.post('/presensi_qr', data);
    },
}